module.exports = __webpack_public_path__ + "img/success.94cad5d7.png";